<div class="col-sm-12 offset-md-1 col-md-10  mt-3">
    <div class="form-logo">
        <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','','_self');">
            <img [src]="this.logo_url" alt="egd-logo">
        </a>
    </div>
    <div class="form-back  h4 my-4">
        <a class="egd-theme" role="button" (click)="this.login_data.goBack(this.backUrl,this.router)">&#8592; Back</a>
    </div>
    <div class="form-heading-section mt-4">
        <h2>Verify Mobile Number to Proceed</h2>
    </div>

    <div class="form-div my-2">
        <ng-container>
            <form #otpForm="ngForm" (ngSubmit)="otpVerifySubmit()" accept-charset="UTF-8" id="register_form">
                <div class="form-group row">
                    <otp-input class="col-12" [isPrimeNg]="false" [otp_data]="this.login_data.otp_data"
                        (otp_resend)="otp_resend()">
                    </otp-input>
                </div>

                <div class="form-group row">
                    <div class="col-sm-12">
                        <div class="form-submit-button  my-3">
                            <button type="submit" class="btn btn-primary font-weight-bold text-white p-2">
                                Login
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </ng-container>

        <div class="mt-3 mx-2">
            <div class="row">
                <app-loading class="col-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER">
                </app-loading>
            </div>
            <app-error-messages [api_result]=" this.login_data.login_api_result"></app-error-messages>
            
            <app-error-messages [api_result]=" this.login_data.otp_data.otp_api_result">
            </app-error-messages>
        </div>
    </div>
    <div class="footer-copyright-section mt-4">
        <p class="footer-copyright-text text-center">
            2025 Copyright <span>&#169;</span> All rights reserved by <a href="javascript:void(0)"
                (click)="openLink('HOMPAGE_BASE_URL','','_self');" style="color: #1850A0;">eGlobalDoctors</a>
        </p>
    </div>
</div>